import { useEffect, useRef, useState } from 'react';
import images from '../../assets/images';
import { formatFileSize, getMenuItems, saveFileMetadata } from '../../utils/helper';
import './MaterialsContainer.scss';
import ConfirmationPopup from '../ConfirmationPopup/ConfirmationPopup';
import MaterialActionsOverlay from '../ActionsOverlay/MaterialActionsOverlay';
import { materialsData } from '../../utils/interface';
import { useAppSelector } from '../../redux/app/hooks';
import { LinearProgress, Tooltip } from '@mui/material';
import { STUDENT_ROLE } from '../../utils/constants';
import { isPlatform } from '@ionic/react';
import { Buffer } from 'buffer';
import { useLocation } from 'react-router-dom';
import { checkFileStatusInDatabase, insertMaterial } from '../../database';

interface MaterialsContainerProps {
    materialsData: [materialsData] | undefined;
    handleOpenFile: (pdfData: materialsData) => void;
    isPdf?: boolean;
    subject?: string;
    subCategory?: string;
    handleMaterialActions: (data: materialsData, action: string) => void;
}

const MaterialsContainer: React.FC<MaterialsContainerProps> = ({ materialsData, handleOpenFile, isPdf, handleMaterialActions, subject, subCategory}) => {
    const { pdfImg, ShareIcon, ShareGif, greyMoreIcon, DeleteGif, CloudDownload, DownloadSuccess, DownloadFailed, csvImg, docsImg, excelPreview, powerpoint, epub } = images;
    const baseUrl = process.env.REACT_APP_FRONTEND_URL;
    const [openConfirmationPopup, setOpenConfirmationPopup] = useState<boolean>(false);
    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
    const [openOverlay, setOpenOverlay] = useState<boolean>(false);
    const [selectedMaterial, setSelectedMaterial] = useState<materialsData | null>(null);
    const [action, setAction] = useState<string>('');
    const [downloadProgress, setDownloadProgress] = useState<{ [key: string]: number }>({});
    const [isDownloading, setIsDownloading] = useState<{ [key: string]: boolean }>({});
    const [downloadComplete, setDownloadComplete] = useState<{ [key: string]: boolean }>({});
    const [downloadFailed, setDownloadFailed] = useState<{ [key: string]: boolean }>({});
    const [fileExists, setFileExists] = useState<{ [key: string]: boolean| undefined }>({});
    const role = useAppSelector((state) => state.auth.role);
    const [responseUrl, setResponseUrl] = useState('');
    const profile = useAppSelector((state) => state.auth.adminProfile);
    const location = useLocation();
    const materialNameRef = useRef<(HTMLDivElement | null)[]>([]);
    const [visibleTooltips, setVisibleTooltips] = useState<boolean[]>([]);
    
    // Function to check if the file exists
    const checkFileExistence = async (material: materialsData) => {
        if(window.electron && window.electron.isElectron()){
        try{
        const response = await window.electron.checkFileStatus(
            material.fileId,
            profile?.getCurrentUser?.nodes[0]?.uId,
            subCategory
        );

        console.log('response======>', response);
        // Check if response is defined and successful
        if (response && response.success) {
            return response.exists; // Return the exists value (true/false)
        }

        console.error('Failed to check file existence:', response);
        return false; // Default return value if the file existence check fails
    }catch(err){
        console.error('Error checking file existence:', err);
        return false; // Return false if there's an error during the check
    }
    }else{
        console.warn("Platform not supported");
    }
    };

    const checkFileExists = async (material: materialsData) => {
        if (window.cordova) {
            try {
                const response = await checkFileStatusInDatabase(
                    material.fileId,
                    profile?.getCurrentUser?.nodes[0]?.uId,
                    subCategory
                );
    
                console.log('File existence response:', response);
                if (response && response.success) {
                    console.log(response,'=======file existance response');
                    return response.exists;
                }
    
                console.error('Failed to check file existence:', response);
                return false;
            } catch (err) {
                console.error('Error checking file existence:', err);
                return false;
            }
        } else {
            console.warn("Cordova is not available");
            return false;
        }
    };

    useEffect(() => {
        const checkFiles = async () => {
            const updatedFileExists: Record<string, boolean| undefined> = {}; // Define the type here
            if (materialsData && materialsData.length > 0) {
                for (const material of materialsData) {
                    const exists = await checkFileExists(material);
                    console.log('Inside the exists of checkFiles', exists);
                    updatedFileExists[material.filepath] = exists; // Use the value from exists
                }
                setFileExists(updatedFileExists);
            }
        };
        checkFiles();
    }, [materialsData]);

    // Check the existence of each file and update the state
    useEffect(() => {
        const checkFiles = async () => {
            const updatedFileExists: Record<string, boolean| undefined> = {}; // Define the type here
            if (materialsData && materialsData.length > 0) {
                for (const material of materialsData) {
                    const exists = await checkFileExistence(material);
                    console.log('Inside the exists of checkFiles', exists);
                    updatedFileExists[material.filepath] = exists; // Use the value from exists
                }
                setFileExists(updatedFileExists);
            }
        };
        checkFiles();
    }, [materialsData]);
    
    // click yes button in confirmation popup
    const onYesButtonClick = () => {
        setOpenConfirmationPopup(false);
        if (selectedMaterial)
            handleMaterialActions(selectedMaterial, action)
    }

    // click no button in confirmation popup
    const onNoButtonClick = () => {
        setOpenConfirmationPopup(false);
    }

    const handleClickMoreIcon = (event: React.MouseEvent<HTMLElement>, material: materialsData) => {
        event.stopPropagation(); // Stop propagation to prevent triggering parent click
        setSelectedMaterial(material);
        if (material?.isclassroom === true) {
            setAnchorEl(event.currentTarget);
            setOpenOverlay(true);
        } else if (material?.isclassroom === false) {
            setAction('share');
            setOpenConfirmationPopup(true);
        }
    };

    const handleCloseActions = () => {
        setAnchorEl(null);
        setOpenOverlay(false);
    };

    const menuItems = getMenuItems(handleCloseActions, handleMaterialActions, setOpenConfirmationPopup, setAction, selectedMaterial);

    const handleDownload = async (material: materialsData) => {
        // if(isPlatform('android')){
            // try {
            //     const materialId = material?.filepath;
            //     const url = baseUrl + material?.filepath;
    
            //     setIsDownloading((prev) => ({ ...prev, [materialId]: true }));
            //     setDownloadProgress((prev) => ({ ...prev, [materialId]: 0 }));
            //     setDownloadComplete((prev) => ({ ...prev, [materialId]: false }));
            //     setDownloadFailed((prev) => ({ ...prev, [materialId]: false }));
    
            //     const fileName = material?.filepath.split('/').pop();
                
            //     const response = await fetch(url);
                
            //     if (!response.ok) {
            //         console.error('Failed to fetch the file', response.statusText);
            //         throw new Error('File download failed');
            //     }
    
            //     const blob = await response.blob();
                
            //     if(window?.cordova){
            //         window.resolveLocalFileSystemURL( window?.cordova?.file?.dataDirectory, (dir: any) => {
            //             dir.getFile(fileName, { create: true }, (fileEntry: any) => {
            //                 fileEntry.createWriter((fileWriter: any) => {
            //                     fileWriter.onwriteend = () => {
            //                         saveFileMetadata(fileName, { subCategory, subject });
            //                         fileEntry.file(() => {
            //                             setDownloadProgress((prev) => ({ ...prev, [materialId]: 100 })); // Set progress to 100%
            //                             setDownloadComplete((prev) => ({ ...prev, [materialId]: true }));
            //                                 setTimeout(() => {
            //                                 setDownloadComplete((prev) => ({ ...prev, [materialId]: false }));
            //                                 setIsDownloading((prev) => ({ ...prev, [materialId]: false }));
            //                                 setDownloadProgress((prev) => ({ ...prev, [materialId]: 0 }));
            //                             }, 2000);
            //                         }, (error: any) => {
            //                             console.error('File does not exist after write', error);
            //                             throw new Error('File verification failed');
            //                         });
            //                     };
            //                     fileWriter.onerror = (e: any) => {
            //                         console.error('File write failed', e);
            //                         setDownloadFailed((prev) => ({ ...prev, [materialId]: true }));
            //                         setTimeout(() => {
            //                             setDownloadFailed((prev) => ({ ...prev, [materialId]: false }));
            //                         }, 5000);
            //                     };
            //                     fileWriter.write(blob);
            //                 }, (error: any) => {
            //                     console.error('Failed to create writer', error);
            //                     throw new Error('File creation failed');
            //                 });
            //             }, (error: any) => {
            //                 console.error('Failed to get file entry', error);
            //                 throw new Error('File entry access failed');
            //             });
            //         });
            //     }
            // } catch (error) {
            //     console.error('Download error:', error);
            //     setIsDownloading((prev) => ({ ...prev, [material.filepath]: false }));
            //     setDownloadFailed((prev) => ({ ...prev, [material.filepath]: true }));
            //     setTimeout(() => {
            //         setDownloadFailed((prev) => ({ ...prev, [material.filepath]: false }));
            //     }, 5000);
            // }

        //     try {
        //         const materialId = material?.filepath;
        //         let url = baseUrl + material?.filepath;

        //         const parts = material.filepath.split('.');                
                
        //         const extension = parts.length > 1 ? parts?.pop() : undefined;                

        //         if (extension?.toLowerCase() && ['doc', 'docx', 'ppt', 'pptx'].includes(extension?.toLowerCase())) {
        //             // Change the URL to end with .pdf
        //             url = url.replace(/\.(doc|docx|ppt|pptx)$/, '.pdf');
        //         }                
                
        //         setIsDownloading((prev) => ({ ...prev, [materialId]: true }));
        //         setDownloadProgress((prev) => ({ ...prev, [materialId]: 0 }));
        //         setDownloadComplete((prev) => ({ ...prev, [materialId]: false }));
        //         setDownloadFailed((prev) => ({ ...prev, [materialId]: false }));
                
        //         const response = await fetch(url);
        //         if (!response.ok) throw new Error('File download failed');
                
        //         const blob = await response.blob();
        //         const arrayBuffer = await blob.arrayBuffer();
        //         const fileData = new Uint8Array(arrayBuffer);

        //         console.log(fileData,'=====fileData');
                    
        //         // Insert material data into the database
        //         const materialData = {
        //             fileId: material.fileId,
        //             userId: profile?.getCurrentUser?.nodes[0]?.uId,
        //             filename: material.filename,
        //             filetype: subCategory?.toLocaleLowerCase()?.includes('image') ? 'image' : material.filetype,
        //             filepath: material.filepath,
        //             filesize: material.filesize,
        //             filedata: fileData,
        //             fileLocation: subCategory,
        //             subject: subject,
        //         };

        //         console.log(materialData,'=====materialData');
                
        //         await insertMaterial(materialData);
    
        //         console.log('Download and metadata storage successful');
        //         const exists = await checkFileExists(material);
        //         setFileExists((prev) => ({ ...prev, [material.filepath]: exists }));

        //         setDownloadProgress((prev) => ({ ...prev, [materialId]: 100 }));
        //         setDownloadComplete((prev) => ({ ...prev, [materialId]: true }));
        //         setTimeout(() => {
        //             setDownloadComplete((prev) => ({ ...prev, [materialId]: false }));
        //             setIsDownloading((prev) => ({ ...prev, [materialId]: false }));
        //             setDownloadProgress((prev) => ({ ...prev, [materialId]: 0 }));
        //         }, 5000);
        //     } catch (error) {
        //         console.error('Download error:', error);
        //         setIsDownloading((prev) => ({ ...prev, [material.filepath]: false }));
        //         setDownloadFailed((prev) => ({ ...prev, [material.filepath]: true }));
        //         setTimeout(() => {
        //             setDownloadFailed((prev) => ({ ...prev, [material.filepath]: false }));
        //         }, 5000);
        //     }
    
        // }
        if (window?.electron && window.electron.isElectron()) {
            const materialId = material?.filepath;
            let url = baseUrl + material.filepath;

            // Extract the file extension
            const parts = material.filepath.split('.');
            const extension = parts.length > 1 ? parts?.pop() : undefined;
            
            // Check for specific extensions and change the URL if necessary
            if (extension?.toLowerCase() && ['doc', 'docx', 'ppt', 'pptx'].includes(extension?.toLowerCase())) {
                // Change the URL to end with .pdf
                url = url.replace(/\.(doc|docx|ppt|pptx)$/, '.pdf');
            }

            try {
                console.log('materials==========>', material, 'subcategory=======>', subCategory,"url for download==========>",url);
    
                // Show initial download states
                setIsDownloading((prev) => ({ ...prev, [materialId]: true }));
                setDownloadProgress((prev) => ({ ...prev, [materialId]: 0 }));
                setDownloadComplete((prev) => ({ ...prev, [materialId]: false }));
                setDownloadFailed((prev) => ({ ...prev, [materialId]: false }));
                const response = await fetch(url);
                if (!response.ok) throw new Error('File download failed');
    
                // Get file blob
                const blob = await response.blob();
                const arrayBuffer = await blob.arrayBuffer();
                const fileData = Buffer.from(arrayBuffer);
    
                // Calculate total file size for progress tracking
                const fileSize = fileData.length;
                let downloadedSize = 0;
                // Send the file metadata and file data to the main process to store in SQLite
                const saveResponse = await window.electron.saveMaterial({
                    fileId: material.fileId,
                    userId: profile?.getCurrentUser?.nodes[0]?.uId,
                    filename: material.filename,
                    filetype: subCategory?.toLocaleLowerCase()?.includes('image') ? 'png' : material.filetype,
                    filepath: material.filepath,
                    filesize: material.filesize,
                    filedata: fileData,
                    fileLocation: subCategory,
                    subject: subject,
                }, url);
                if (saveResponse.success === false){
                    throw new Error(saveResponse.message || 'Error saving material to SQLite');
                }

                // Simulate progress: for Electron, the download is complete at once, so we simulate chunk progress
                const interval = setInterval(async () => {
                    if (downloadedSize < fileSize) {
                        downloadedSize += fileSize / 10; // Simulate 10% increments
                        const progress = Math.min(Math.floor((downloadedSize / fileSize) * 100), 95);
                        setDownloadProgress((prev) => ({ ...prev, [materialId]: progress }));
                    } else {
                        clearInterval(interval);
    
                        // Set final progress to 100% and mark download as complete
                        setDownloadProgress((prev) => ({ ...prev, [materialId]: 100 }));
                        setDownloadComplete((prev) => ({ ...prev, [materialId]: true }));
                        // Check if the file exists after the download
                        const exists = await checkFileExistence(material);
                        setFileExists((prev) => ({ ...prev, [material.filepath]: exists }));

                        // Reset state after a delay
                        setTimeout(() => {
                            setDownloadComplete((prev) => ({ ...prev, [materialId]: false }));
                            setIsDownloading((prev) => ({ ...prev, [materialId]: false }));
                            setDownloadProgress((prev) => ({ ...prev, [materialId]: 0 }));
                        }, 5000);
                    }
                }, 300); // Simulate progress every 300ms
    
                console.log('Download and metadata storage successful');
            } catch (error) {
                console.error('Download error:', error);
                setIsDownloading((prev) => ({ ...prev, [material.filepath]: false }));
                setDownloadFailed((prev) => ({ ...prev, [material.filepath]: true }));
                setTimeout(() => {
                    setDownloadFailed((prev) => ({ ...prev, [material.filepath]: false }));
                }, 5000);
            }
        } else {
            try {
                const materialId = material?.filepath;
                setIsDownloading((prev) => ({ ...prev, [materialId]: true }));
                setDownloadProgress((prev) => ({ ...prev, [materialId]: 0 }));
                setDownloadComplete((prev) => ({ ...prev, [materialId]: false }));
                setDownloadFailed((prev) => ({ ...prev, [materialId]: false }));

                console.log(materialId,'=====filePath');

                const url = baseUrl + material?.filepath;
                const response = await fetch(url);
                if (!response.ok) {
                    console.error('Failed to fetch the file', response.statusText);
                    setIsDownloading((prev) => ({ ...prev, [materialId]: false }));
                    setDownloadFailed((prev) => ({ ...prev, [materialId]: true }));
                    setTimeout(() => {
                        setDownloadFailed((prev) => ({ ...prev, [materialId]: false }));
                    }, 5000);
                    return;
                }

                const reader = response.body?.getReader();
                let receivedLength = 0;
                const chunks = [];

                while (true) {
                    const { done, value } = await reader!.read();
                    if (done) break;

                    chunks.push(value);
                    receivedLength += value.length;

                    // Incremental progress based on the number of chunks
                    setDownloadProgress((prev) => ({ ...prev, [materialId]: Math.min(prev[materialId] + 5, 95) })); // Up to 95%
                }

                const blob = new Blob(chunks);
                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob);
                link.download = material?.filepath;
                link.click();
                // Add a small delay before updating the state
                await new Promise(resolve => setTimeout(resolve, 500));
                // setIsDownloading(false);
                setDownloadComplete((prev) => ({ ...prev, [materialId]: true }));
                setDownloadProgress((prev) => ({ ...prev, [materialId]: 100 })); // Set to 100% on completion
                // Hide the progress and complete message after 5 seconds
                setTimeout(() => {
                    setDownloadComplete((prev) => ({ ...prev, [materialId]: false }));
                    setIsDownloading((prev) => ({ ...prev, [materialId]: false }));
                    setDownloadProgress((prev) => ({ ...prev, [materialId]: 0 }));
                }, 5000);
            } catch (error) {
                console.error('Download error:', error);
                setIsDownloading((prev) => ({ ...prev, [material.filepath]: false }));
                setDownloadFailed((prev) => ({ ...prev, [material.filepath]: true }));
                setTimeout(() => {
                    setDownloadFailed((prev) => ({ ...prev, [material.filepath]: false }));
                }, 5000);
            }
       }
    };

    const handleMouseEnter = (index: number) => {
        const ref = materialNameRef.current[index];
      
        if (ref) {
          const isOverflowing = ref.scrollWidth > ref.clientWidth;
          setVisibleTooltips((prev) => {
            const updated = [...prev];
            updated[index] = isOverflowing;
            return updated;
          });
        }
      };
    
      const handleMouseLeave = (index: number) => {
        setVisibleTooltips((prev) => {
          const updated = [...prev];
          updated[index] = false;
          return updated;
        });
      };
    

    return (
        <div className={`${materialsData && materialsData?.length > 0 ? 'materialsContainer' : 'noData'}`}>
            {materialsData && materialsData.length > 0 ? (
                materialsData.map((material: materialsData, index: number) => (
                    <div className="materialCardContainer" key={material.filepath} onClick={() => handleOpenFile(material)}>
                        <div className="previewImageContainer">
                            <img 
                                src={isPdf === false ? baseUrl + material?.filepath : (material?.filetype === "pdf" ? pdfImg : material?.filetype === "csv" ? csvImg : (material?.filetype === "xls" || material?.filetype === "xlsx") ? excelPreview : (material?.filetype === "docx" || material?.filetype === "doc" ) ? docsImg : (material?.filetype === "ppt" || material?.filetype === "pptx") ? powerpoint : material?.filetype === "epub" ? epub : pdfImg)} 
                                alt="MaterialImg" 
                                className={`${material?.filetype === "pdf" ? "materialCardImagePdf" :  location.pathname.split("/").slice(2).join("/") === "images/materials" ? 'materialCardImageforImage':"materialCardImage"} ${material?.filetype === "epub" ? "epubImg" : ""} ${!(isPdf === false) && 'previewStaticImageStyle'}`} 
                            />
                        </div>
                        <div className="materialCardProgressCtn">
                            {(isDownloading[material?.filepath] && role === STUDENT_ROLE) && (
                                <LinearProgress variant="determinate" value={downloadProgress[material?.filepath]}
                                    style={{ backgroundColor: '#ECECEC', height: '2px' }}
                                    sx={{
                                        '& .MuiLinearProgress-bar': {
                                            backgroundColor: '#4086F4',
                                            height: '2px'
                                        },
                                    }} />
                                )} 
                            </div>
                        <div className="materialCardContentCtn">
                            <Tooltip
                                title={material?.filename}
                                open={visibleTooltips[index] || false}
                                placement="bottom"
                                disableInteractive
                            >
                                <div className="materialCardContent" ref={(el) => ( materialNameRef.current[index] = el)} onMouseEnter={() => handleMouseEnter(index)} onMouseLeave={() => handleMouseLeave(index)}
                                >
                                    {material.filename}
                                </div>
                            </Tooltip>
                            <div className="materialCardBtnCtn">
                                <div className='materialDownloadCtn'>
                                    <div className="materialSize">Size: {material?.filesize ? formatFileSize(material.filesize) : '0 Mb'}</div>
                                    {/* {(downloadComplete[material?.filepath] && role === STUDENT_ROLE) && (
                                        <div className="downloadCompleteMessage">
                                            {downloadComplete[material?.filepath] ? "Downloaded" : downloadFailed[material?.filepath] ? "Not downloaded" : ""}
                                        </div>
                                    )} */}
                                </div>
                                {role === STUDENT_ROLE ?
                                    <div
                                        className="materialDownload"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            if (!fileExists[material?.filepath]) {
                                                handleDownload(material);
                                            } else {
                                                handleOpenFile(material);
                                            }
                                        }}
                                    >
                                        {downloadComplete[material?.filepath] ? (
                                            <img src={DownloadSuccess} alt="DownloadSuccess" />
                                        ) : downloadFailed[material?.filepath] ? (
                                            <img src={DownloadFailed} alt="DownloadFailed" />
                                        ) : fileExists[material?.filepath] ? (
                                            <img src={DownloadSuccess} alt="AlreadyDownloaded" />
                                        ) : (
                                            <img src={CloudDownload} alt="CloudDownload" />
                                        )}
                                    </div>
                                    :
                                    <div className="materialCardBtn" onClick={(event) => handleClickMoreIcon(event, material)} >
                                        {material?.isclassroom ?
                                            <img src={greyMoreIcon} alt="action" className='moreIcon' /> :
                                            <img src={ShareIcon} alt="share" className='shareIcon' />
                                        }
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                ))
            ) : (
                <div className='noDataFoundStyle'>No data found</div>
            )}
            <MaterialActionsOverlay
                anchorEl={anchorEl}
                open={openOverlay}
                handleClose={handleCloseActions}
                menuItems={menuItems}
                actionsHeight={'90px'}
                position="left"
            />
            <ConfirmationPopup
                open={openConfirmationPopup}
                message={action === "share" ? `Are you sure you want to Share this file with your Class?` : `Are you sure you want to Delete this file from the Classroom?`}
                gifData={action === "share" ? ShareGif : DeleteGif}
                yesButtonFunctionality={onYesButtonClick}
                noButtonFunctionality={onNoButtonClick}
                messageWidth={'195px'}
            />
            </div>
    )
}

export default MaterialsContainer;
